import isArray from 'lodash/isArray';

import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const sessionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSessions: builder.query({
      query: (filters) => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          if (isArray(filters[k])) {
            if (filters[k].length) {
              acc.set(k, filters[k].join(','));
            }
          } else {
            acc.set(k, filters[k]);
          }
          return acc;
        }, new URLSearchParams());
        return `session/?${qs}`;
      },
      providesTags: ['Appointment', 'Session'],
    }),
    createSession: builder.mutation({
      query: ({ body }) => ({
        url: `session/`,
        method: 'POST',
        body: body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;  // Wait for the request to be successful
          dispatch(apiSlice.util.invalidateTags([{ type: 'Session'}, {type: 'Appointment'}, {type: 'Availability'}]));  // Invalidate the cache on success
        } catch (error) {
          // Handle error if needed, cache is not invalidated if the request fails
          console.error('Create failed', error);
        }
      },
    }),
    updateSession: builder.mutation({
      query: ({ id, body }) => ({
        url: `session/${id}/`,
        method: 'PUT',
        body: body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;  // Wait for the request to be successful
          dispatch(apiSlice.util.invalidateTags([{ type: 'Session'}, {type: 'Appointment'}, {type: 'Availability'}]));  // Invalidate the cache on success
        } catch (error) {
          // Handle error if needed, cache is not invalidated if the request fails
          console.error('Update failed', error);
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSessionsQuery,
  useCreateSessionMutation,
  useUpdateSessionMutation,
  // useRemoveSessionMutation
} = sessionApi;
